/***
 * https://difhub.com/view/organizations/Business%20Systems/systems/Settlement/applications/Billing/datasets/OperationSpec/versions/1
 */
export class OperationSpecDto {
  id: string;
  type: string; // enum from api
  method: string; // enum from api
  deliveryDetail: string;
  format: string;
  contacts: string[] = [];
  unit: number;
  category: string; // enum from api

  constructor(d?: OperationSpecDto) {
    if (!d) {
      return;
    }

    this.id = d.id;
    this.type = d.type;
    this.method = d.method;
    this.deliveryDetail = d.deliveryDetail;
    this.format = d.format;
    this.unit = d.unit;
    this.category = d.category;
    this.contacts = d.contacts;
  }
}
